import { ChangeEvent } from 'react'
import styles from '../../AdminTools.module.css'

interface HeaderAlignedMessageTextProps {
  value: string
  onChange: (value: string) => void
  disabled?: boolean
}

export const HeaderAlignedMessageText = ({
  value,
  onChange,
  disabled,
}: HeaderAlignedMessageTextProps) => {
  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    onChange(e.target.value)
  }

  return (
    <div className={styles.headerAlignedRow}>
      <div className={styles.headerAlignedLabel}>Meddelande</div>
      <textarea
        className={styles.messageTextArea}
        rows={5}
        maxLength={200}
        placeholder="Max 200 tecken"
        value={value}
        onChange={handleChange}
        disabled={disabled}
      />
    </div>
  )
}
